// a foreign postal code is alphanumeric ('SW1A 1AA' -> 'SW1A1AA') and has to survive into billingAddress.
export const normalizeZipCode = (value: string | undefined): string | undefined => value?.replace(/\W/g, '');
